import appSettings from 'wanderu-config';
import {
    selectLocale,
    selectCurrency,
} from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { identifyUser, SnowplowService } from 'wanderu-service-analytics';

import {
    actions as userInfoActions,
    selectors as userInfoSelectors,
} from '../../appstate/userInfo';
import { actions } from './base';

const logger = Logger.getLogger('wanderu-duck-account');

function reset() {
    return actions.reset();
}

function update(userNameInfo) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork());

        let meta;
        let error;
        try {
            const updatedNameInfo = await AccountService.saveUserInfo(
                userNameInfo,
            );

            dispatch(userInfoActions.updateUserName(updatedNameInfo));

            const identityId = userInfoSelectors.selectIdentityId(getState());
            const userInfo = userInfoSelectors.selectUserInfo(getState());
            const locale = selectLocale(getState());
            const currency = selectCurrency(getState());
            identifyUser({
                email: userInfo.email,
                identityId,
                firstName: userInfo.firstName,
                lastName: userInfo.lastName,
                source: 'account_update',
                locale,
                currency,
            });

            return;
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('updateUserName', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(meta, error));
        }
    };
}

export {
    reset,
    update,
};
